import { Injectable, inject } from '@angular/core';

import {
    BETSLIP_MESSAGES_PROVIDER_INJECTION_TOKEN,
    IBetslipMessagesProviderService,
    ILinearBetslipMessages,
    ILinearBetslipMessagesProviderService,
} from '@frontend/sports/betslip/core/feature';
import { Sitecore } from '@frontend/sports/common/client-config-data-access';

@Injectable()
export class LinearBetslipMessageProviderService implements ILinearBetslipMessagesProviderService {
    private sitecore = inject(Sitecore);
    private messageProvider = inject<IBetslipMessagesProviderService>(BETSLIP_MESSAGES_PROVIDER_INJECTION_TOKEN);

    private messages: ILinearBetslipMessages;

    getMessages(): ILinearBetslipMessages {
        if (!this.messages) {
            this.initMessages();
        }

        return this.messages;
    }

    private initMessages(): void {
        const betslipMessages = this.messageProvider.getMessages();

        this.messages = { linear: this.sitecore.betslip.linear, betslip: betslipMessages };
    }
}
